import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleUpdater = () => {
  const location = useLocation();

  // Store titles in an object with route paths as keys
  const titles = {
    '/': 'MEDtools.lk',
    '/contact': 'MEDtools.lk | Contact Us',
    '/about': 'MEDtools.lk | About Us',
    '/store': 'MEDtools.lk | Store',
    '/store/tabs': 'MEDtools.lk | Store',
    '/store/tab-accessories': 'MEDtools.lk | Store',
    '/store/steth-accessories': 'medtools.lk | Store',
    '/cart': 'MEDtools.lk | Cart',
    '/checkout': 'MEDtools.lk | Checkout',
    '/profile': 'MEDtools.lk | Profile',
  };

  useEffect(() => {
    let title = titles[location.pathname] || 'MEDtools.lk';

    // For dynamic titles like product pages, check for dynamic params
    if (location.pathname.startsWith('/product/') && titles['/product/:id']) {
      const productId = location.pathname.split('/')[2]; // Extract product ID from the URL
      title = titles['/product/:id'](productId); // Set dynamic title
    }

    document.title = title;
  }, [location.pathname]); // Dependency on pathname to update title on route change

  return null; // This component doesn't need to render anything, it just updates the document title
};

export default TitleUpdater;
